<template>
  <ExActionsPopUp
    :value="show"
    headline="Reactivate Checkpoint"
    :icon="'org_icon_checkpoint'"
    :htmlInfo="info"
    :destructive="false"
    actionLabel="Reactivate"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="$emit('onReactivate')"
    @input="$emit('onClose')"
    data-testid="reactivate-checkpoint-popup"
    :backgroundPatternBottomRight="true"
    :applyBorderClass="true"
    :width="500"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
});

defineEmits(["onReactivate", "onClose"]);

const formattedInfo = computed(() => {
  return `<div style="max-width: 260px; margin: 0 auto; margin-top: 26px;">You are about to reactivate checkpoint ${props.name}.</div>`;
});

const info = computed(() => {
  return formattedInfo.value;
});
</script>
